'use client';

import { atom } from 'jotai';

import { calculationAtom } from './Calculation.atom';

export const currentProductAtom = atom(get => {
  const calculation = get(calculationAtom);
  if (!calculation) return null;
  return calculation.products?.[calculation.selectedProduct] ?? null;
});
